import React, {FC} from 'react'

interface Props {
 title: string
 children: React.ReactNode
}

const NotificationSection: FC<Props> = ({
 title,
 children,
}) => {
 return (
  <div className='mb-8'>
   <div className='text-[14px] text-[#7E8299] mb-4'>
    {title}
   </div>

   {children}
  </div>
 )
}

export default NotificationSection
